module.exports = __webpack_public_path__ + "img/h5-item-3.8036cf5f.png";